import React from 'react';
import { Row, Col } from 'bee-layout';
import { isEmpty, localeLang } from '@platform/api';
import { compareTimeFunction } from '@platform/api';
import HotKeys from '../HotKeys';

require('bee-layout/build/Layout.css');

let functionList = {};
let resultValue = [];
let _multiLang = {};
function selectDateFunction(callback, item, notconverttimezones) {
    resultValue.push(item);
    if (resultValue.length === 2) {
        pickerState(false);
        if (compareTimeFunction(resultValue[0], resultValue[1], notconverttimezones)) { callback(resultValue); } else { callback([resultValue[1], resultValue[0]]); }
        resultValue = [];
    } else {
        this.forceUpdate();
    }
}
function clear(callback) {
    resultValue = [];
    //pickerState(false);
    callback('');
}
function pickerState(flag) {
    // let pickerDOM = document.getElementsByClassName('rc-calendar-picker')[0];
    // if (pickerDOM) {
    // 	pickerDOM.style.display = flag ? 'block' : 'none';
    // } else {
    // }
    let pickerDOM = document.getElementsByClassName('rc-calendar rc-calendar-range')[0];
    if (pickerDOM && !flag) {
        var parent = pickerDOM.parentElement;
        // 删除:
        var removed = parent.removeChild(pickerDOM);
    }
}
export const setMultiLang = (multiLang = {}) => {
    functionList = {
        '#day(-1)#': multiLang['page-search-0060'],
        '#day(0)#': multiLang['page-search-0061'],
        '#day(1)#': multiLang['page-search-0062'],
        '#month(-1)#': multiLang['page-search-0063'],
        '#month(0)#': multiLang['page-search-0064'],
        '#month(1)#': multiLang['page-search-0065'],
        '#week(-1)#': multiLang['page-search-0066'],
        '#week(0)#': multiLang['page-search-0067'],
        '#week(1)#': multiLang['page-search-0068'],
        '#quarter(-1)#': multiLang['page-search-0069'],
        '#quarter(0)#': multiLang['page-search-0070'],
        '#quarter(1)#': multiLang['page-search-0071'],
        '#year(-1)#': multiLang['page-search-0072'],
        '#year(0)#': multiLang['page-search-0073'],
        '#year(1)#': multiLang['page-search-0074'],
        '#lastDayOfMonth#': multiLang['page-search-0075'],
        '#lastDayOfWeek#': multiLang['page-search-0076'],
        '#finalDayOfLastMonth#': multiLang['page-search-0077'],
        '#year(-2)#': multiLang['page-search-0095'],
    };
    _multiLang = multiLang;
};
export const getTimeFunctionDisplay = value => {
    if (Array.isArray(value)) {
        return value.map(item => functionList[item] || '');
    } else if (typeof value == 'string') {
        return functionList[value] || '';
    } else {
        return '';
    }
};

export const checkFuntionValue = value => {
    if (value && value[0] && value[1]) {
        return Object.keys(functionList).indexOf(value[0]) !== -1 && Object.keys(functionList).indexOf(value[1]) !== -1;
    }
};
export const getTimeFunctionLabel = (value, show, openCallBack) => {
    let startLabel = functionList[value[0]] || '';
    let endLabel = functionList[value[1]] || '';
    return show && startLabel && endLabel ? (
        <span
            className="date-picker-mask"
            onClick={e => {
                // e.preventDefault();
                // e.stopPropagation();
                openCallBack(true);
            }}
        >
            {startLabel + '~' + endLabel}
        </span>
    ) : null;
};
// value = 选择的时间 callback = 单击回调 show  = 是否显示时间函数
// hiddenFunList = [
//     '#day(-1)#',//昨日
//     '#day(0)#',//今日
//     '#day(1)#',//明日
//     '#month(-1)#',//上月
//     '#month(0)#',//本月
//     '#month(1)#',//下月
//     '#week(-1)#',//上周
//     '#week(0)#',//本周
//     '#week(1)#',//下周
//     '#quarter(-1)#',//上季
//     '#quarter(0)#',//本季
//     '#quarter(1)#',//下季
//     '#year(-1)#',//去年
//     '#year(0)#',//今年
//     '#year(1)#',//明年
//     '#lastDayOfMonth#',//当月最后一天
//     '#lastDayOfWeek#',//本周最后一天
//     '#finalDayOfLastMonth#',//上月最后一天
// ]
export function getDateFunNode(value = [], callback, show, hiddenFunList, notconverttimezones) {
    if (!show) return;
    let spen = 2;
    //resultValue=[];
    if (isEmpty(value) || resultValue.length == 1) {
        value = resultValue;
    }
    let newFunList = { ...functionList };
    if (Array.isArray(hiddenFunList)) {
        hiddenFunList.forEach(element => {
            delete newFunList[element];
        });
    }

    let splitRowSign = 0; // 分组标识
    let splitColSign = [2, 5, 8, 11, 14, 16];
    let largeSign = [15, 16, 17];

    return (
        <React.Fragment>
            <div className={"function-node-content " + localeLang}>
                {/* <p className="clear">
					{isEmpty(value) ? (
						''
					) : (
							<span onClick={clear.bind(this, callback)}>
								<i style={{ fontSize: '15px' }} className="iconfont icon-riliqingkong" />
							</span>
						)}
				</p> */}
                <HotKeys
                    keyMap={{
                        rightHandler: ['right'],
                        leftHandler: ['left'],
                        enterHander: ['enter'],
                    }}
                    handlers={{
                        rightHandler: () => {
                            if (document.activeElement.nextElementSibling) {
                                document.activeElement.nextElementSibling.focus();
                            }
                        },
                        leftHandler: () => {
                            if (document.activeElement.previousElementSibling) {
                                document.activeElement.previousElementSibling.focus();
                            }
                        },
                        enterHander: () => {
                            if (document.activeElement) {
                                document.activeElement.click();
                            }
                        },
                    }}
                    clearOpenPanel={false}
                >
                    <Row className="content">
                        {Object.keys(newFunList).map((item, index) => {
                            // let isSplitRow = isLastDay(item);
                            // spen = isSplitRow ? 4 : 2;
                            // splitRowSign = isSplitRow ? splitRowSign + 1 : 0;
                            // let align = (index % 6 < 3 ? 'text-left' : 'text-right') + (splitRowSign === 1 ? ' text-left' : '');
                            return [
                                <Col
                                    //tabindex="0"
                                    tabindex={index === 0 ? '0' : '-1'}
                                    // className={`
									// 	fun-plan-area 
									// 	${align} 
									// 	${splitColSign.includes(index) && 'split-col'}
									// 	${largeSign.includes(index) && 'large-item'}
									// `}
                                    className={'fun-plan-area'}
                                    // lg={spen}
                                    // md={spen}
                                    // sm={spen}
                                    // xs={spen}
                                    itemNum={index}
                                    onClick={selectDateFunction.bind(this, callback, item, notconverttimezones)}
                                    onKeyDown={e => {
                                        if (e.keyCode !== 27) {
                                            e.stopPropagation();
                                        }
                                    }}
                                >
                                    <span className={value.includes(item) && 'select'}>{newFunList[item]}</span>
                                </Col>,
                            ];
                        }, this)}
                    </Row>
                </HotKeys>
            </div>
            <span
                className={`clear-function ${isEmpty(value) ? 'disabled' : ''}`}
                onClick={() => {
                    if (!isEmpty(value)) {
                        clear.call(this, callback);
                    }
                }}
            > {_multiLang['page-search-0086']}
            </span>
        </React.Fragment>
    );
}

function isLastDay(str) {
    return '#lastDayOfMonth# #lastDayOfWeek# #finalDayOfLastMonth#'.indexOf(str) != -1 || false;
}
